export default __webpack_public_path__ + "static/11.01-9f73a9fea853308c2d82fb97b81076de.png";